import { render } from "./ServiciosProgramadosListadoSolicitudes.vue?vue&type=template&id=080d3abc&ts=true"
import script from "./ServiciosProgramadosListadoSolicitudes.vue?vue&type=script&lang=ts"
export * from "./ServiciosProgramadosListadoSolicitudes.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__